module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10023.522f910c.jpg";